import { typedValue } from 'app/infrastructure/data/convert';
import { Value, SelectedValue } from 'app/types-shared';

import get from 'lodash/get';
const EMPTY_ARRAY: any[] = [];

export function getValue(model: any, path: string): SelectedValue {
  
  const match: any = get(model, path) || [];

  return defaultValueStrategy(match);
}

/**
 * Partially applied function that extends the Value with a presedence strategy to get the 
 * value depening on the existence of V and D properties.
 * Idea is make it easier for
 * components to get their DisplayValue, options and current value in a predictable way.
 * 
 * This can probably be refactored into a common selector
 * 
 *  - value: is `value` property of first item in valueitems
 *  - valueItems is an array of values mapped to type ComplexValue
 */
function defaultValueStrategy(values: Value[]): SelectedValue {

  if (!Array.isArray(values)) {
    throw new Error('value must be an array');
  }

  const isValue = (value: any) => !(Object.is(value, null) || Object.is(value, undefined));                                       
  const maybe = (value: any, prop: string) => isValue(value) ? { [prop]: value } : {} ;

  const selectedValues: SelectedValue[] = values.map((item: any) => {

    if ( !isValue( Object(item).value ) ){
      return undefined;
    }

    const description = item.description || '';    
    const value = typedValue(item.value);

    const optionals = {
      ...maybe(item.longDescription, 'longDescription'),
      ...maybe(item.icon, 'icon'),      
      ...maybe(item.backgroundColor, 'backgroundColor'),
      ...maybe(item.foregroundColor, 'foregroundColor'),
      ...maybe(item.categoryId, 'categoryId')
    };

    return {
      value,
      description,      
      ...optionals
    };

  }).filter( isValue ) as any;

  const firstItemsValue: any = (selectedValues.length ?
    selectedValues[0].value : undefined);

  return {

    // the .value property of the first item
    value: firstItemsValue,

    // the first item object
    valueItem: selectedValues.length ? selectedValues[0] : undefined,

    // all item objects as array
    valueItems: selectedValues.length ? selectedValues : EMPTY_ARRAY

  } as any;

}
